import React from 'react';

function PageNotFound() {
  return (
    <>
      <div className="main_containerssss">
        <div className="main_container team section-bg">
          <div className="container">
            <div className="section-title" data-aos="fade-up">
              <h2>404</h2>
              <p>Page not found.</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default PageNotFound;
